import axios from 'axios'
import qs from 'qs'

import heals_config from '../heals-config'

if(process.env.NODE_ENV === 'production'){
    //开发环境走代理模式，请配置proxyTable中target
    axios.defaults.baseURL = heals_config.getBaseUrl()
} 
axios.defaults.headers.get['Accept'] = 'text/html,application/xml,application/json';

export function setAuthToken(token){
    axios.defaults.headers.post['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.get['Authorization'] = `Bearer ${token}`
}

export function get(url, params = {}, context, otherParams = {}) {
    return new Promise((resolve, reject) => {
        url += "?";
        let keys = Object.keys(params); //处理对象，返回可枚举的属性数组
        for (let i = 0, length = keys.length; i < length; i++) {
            if (i === 0) {
                url += keys[i] + "=";
                url += params[keys[i]];
            } else {
                url += "&" + keys[i] + "=";
                url += params[keys[i]];
            }
        }
        url = encodeURI(url);//对url 进行编码
        axios.get(url).then(res => {
            if (res.status == 200) {
                resolve(res.data)
            } else {
                reject('请求错误')
            }
        }).catch(err => {
            handerFetchError(context, err)
            reject(err)
        })
    })
}


export function post(url, params = {}, context, otherParams = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, params).then(res => { //序列化字符串
            if (res.status == 200) {
                resolve(res.data)
            } else {
                reject('请求错误')
            }
        }).catch(err => {
            handerFetchError(context, err)
            reject(err)
        })
    })
}

/**
 * 处理请求错误
 * @param {当前} context 
 */
function handerFetchError(context, err) {
    let error = err
    try {
        if (err.response.data.error_messages) {
            error = err.response.data.error_messages
        }
    } catch (error) {
    }
    context.$toasted.show(error, {
        theme: "bubble",
        position: "top-left",
        duration: 4000,
        fullWidth: true
    });
}



//////////////////
// WEBPACK FOOTER
// ./static/request.js
// module id = null
// module chunks = 